import React from 'react';

import { formatLinkBlockToUrl } from '$utilities/format';
import IconCircle from '$partials/icons/icon-circle';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').ModuleContainer}
 */
const ModuleContainer = ({
    children,
    ctaLabel,
    ctaLink,
    heading,
    id,
    renderChildrenBelow = false,
    text,
}) => {
    return (
        <div
            className='layout-container px-layout-outer'
            id={id}>
            <div className='flex md:block border-t border-black pt-18'>
                <div
                    aria-hidden={true}
                    className='w-side-col flex-shrink-0 md:hidden'>
                    <IconCircle className='w-[20px] h-[20px] sm:w-[40px] sm:h-[40px] mt-8 sm:mt-0' />
                </div>

                <div className='w-full flex gap-8 md:gap-0 flex-col md:flex-row'>
                    <div className='md:w-4/12 flex pr-3'>
                        <div
                            aria-hidden={true}
                            className='w-side-col flex-shrink-0 hidden md:block'>
                            <IconCircle className='w-[20px] h-[20px] sm:w-[40px] sm:h-[40px] mt-8 sm:mt-0' />
                        </div>
                        <div className='pr-8'>
                            <h2 className='type-style-heading-1 max-w-text-length mr-12'>
                                {heading}
                            </h2>

                            {(ctaLabel && ctaLink) &&
                                <a
                                    className='group/button flex justify-between items-center bg-purple text-offwhite rounded min-w-[200px] h-button-height px-12 my-12'
                                    href={formatLinkBlockToUrl(ctaLink)}
                                    rel={ctaLink.linkTo === 'custom_url' ? 'noreferrer' : undefined}
                                    target={ctaLink.linkTo === 'custom_url' ? '_blank' : undefined}>
                                    <span className='pr-12'>
                                        {ctaLabel}
                                    </span>
                                    <span className='group-hover/button:translate-x-[4px] transition-transform'>
                                        →
                                    </span>
                                </a>
                            }
                        </div>
                    </div>

                    <div className='md:w-8/12 pl-3'>
                        {text &&
                            <div
                                className='rich-text type-style-heading-2 md:w-7/8 max-w-text-length mb-30'
                                dangerouslySetInnerHTML={{ __html: text }} />
                        }

                        {!renderChildrenBelow &&
                            <div>
                                {children}
                            </div>
                        }
                    </div>
                </div>
            </div>

            {renderChildrenBelow &&
                <div>
                    {children}
                </div>
            }
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ModuleContainer;
